var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF7F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_8057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM16 21.6667C19.1296 21.6667 21.6667 19.1296 21.6667 16C21.6667 12.8704 19.1296 10.3333 16 10.3333C12.8704 10.3333 10.3333 12.8704 10.3333 16C10.3333 19.1296 12.8704 21.6667 16 21.6667Z",
    fill: "#C1CCF4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_8057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3.14453L31.6667 8.66838L22.3333 34.335L16 16.0017V3.14453Z",
    fill: "#F99096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14282 24.75L12.6071 27.25L21.1785 29.2143L16 16L8.14282 24.75Z",
    fill: "#C23143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03571 5.64453L-4 12.966L3.14286 32.6088L16 16.0017L9.03571 5.64453Z",
    fill: "#F25467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 3.1423L11.3572 1.53516L7.78577 4.3923L16.0001 15.9994V3.1423Z",
    fill: "#FFCDD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.dbe7e1cee9521c136150033a75e43867.svg";
export { ForwardRef as ReactComponent };